import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const SearchBarInnerWrapper = styled(Box).attrs({
  horizontal: true,
  position: 'relative',
  justify: 'center',
  bg: 'background',
  width: '264px',
})`
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 5px;
  &:focus-within {
    border: ${({ hasError, theme }) =>
      hasError
        ? `1px solid ${theme.colors.lightDanger}`
        : `1px solid ${theme.colors.primaryBase}`};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const Container = styled(Box).attrs({
  position: 'relative',
  align: 'center',
})`
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;

export const InputContainer = styled(Box).attrs({
  position: 'relative',
  padding: '0',
  justify: 'center',
})`
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;

export const Form = styled.form`
  width: 213px;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 192px;
  height: 36px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  border-radius: 0 5px 5px 0;
  border-left: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-top: none;
  border-right: none;
  border-bottom: none;
  background: none;

  &:focus {
    border-left: ${({ theme, hasError }) =>
      hasError
        ? `1px solid ${theme.colors.lightDanger}`
        : `1px solid ${theme.colors.primaryBase}`};
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.secondaryText};
  }

  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
    margin-left: 0px;
  }
`;

export const ClearSearch = styled(Box).attrs({})`
  cursor: pointer;
`;

export const IconWrapper = styled(Box).attrs({
  horizontal: true,
  position: 'absolute',
  color: 'secondaryLink',
})`
  top: 12px;
  right: 10px;
  z-index: 1;
`;
